// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1d0DB","icon":"styles_icon__3tPot"};